// frontend/src/lib/auth.ts
import api from "./axios";

/**
 * Properly log out a cookie-session user:
 *  - tell the server to clear the session
 *  - clear any client caches
 *  - hard reload to the login page
 */
export const logout = async () => {
  try {
    await api.post("/auth/logout"); // clears server-side session (sets a fresh empty cookie)
  } catch {
    // ignore network hiccups; we'll still nuke caches and reload
  }

  try {
    // If you keep any client-side hints, clear them too
    sessionStorage.clear();
    localStorage.clear();
  } catch {}

  // Hard reload so SWR/React state is gone and GlobalAuthGate runs cleanly
  window.location.replace("/");
};
